import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type { Store, StoreShowResponse, StoreTheme, UpdateStoreInput } from './stores.types'

/** No store endpoint takes an id: the organization has one store. */
export interface StoreOrganizationScope {
  organizationId: OrganizationId
}

/** Query functions read only the key. */
type StoreQueryContext<TKey> = Pick<QueryFunctionContext<[TKey]>, 'queryKey'>

export async function getStore({
  queryKey: [{ organizationId }],
}: StoreQueryContext<StoreOrganizationScope>) {
  return (
    (await axios.get<StoreShowResponse>('/store', buildAdminRequestConfig({ organizationId }))) ||
    {}
  )
}

export async function updateStore({
  organizationId,
  ...values
}: UpdateStoreInput & StoreOrganizationScope) {
  return axios.put<Store>('/store', values, buildAdminRequestConfig({ organizationId }))
}

/** The preset themes every organization picks from. */
export async function getStoreThemes({
  queryKey: [{ organizationId }],
}: StoreQueryContext<StoreOrganizationScope>) {
  return (
    (await axios.get<StoreTheme[]>('/store/themes', buildAdminRequestConfig({ organizationId }))) ||
    []
  )
}
